module.exports = __webpack_public_path__ + "img/img_kj.0150f56a.png";